let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7yi4t")).then(() => parcelRequire('k6s6p'));